import * as React from 'react';
import { Modal, Input, Checkbox } from 'antd';
import Form, { FormItem } from '../../../../../components/Form';
import PaymentMethodSelect from '../../../../../components/Others/PaymentMethodSelect';

interface IPaymentSettingsModalProps {
  order: GQL.IOrder;
  onSubmit: (data: any) => void;
  onClose: () => void;
}

interface IPaymentSettingsModalState {
  data: {
    paymentMethodId: string;
    paymentTotal: number;
    paid: boolean;
  };
}

class PaymentSettingsModal extends React.Component<IPaymentSettingsModalProps, IPaymentSettingsModalState> {

  private form;

  constructor(props: IPaymentSettingsModalProps) {
    super(props);

    this.state = {
      data: {
        paymentMethodId: props.order.paymentMethod.id,
        paymentTotal: props.order.paymentTotal,
        paid: props.order.paid,
      },
    };

    this.form = React.createRef;

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  public render() {
    const { order } = this.props;

    return (
      <div>
        <Modal
          title="Payment settings"
          visible={true}
          okText={'Save changes'}
          onOk={this.onSubmit}
          onCancel={this.props.onClose}
          destroyOnClose={true}
          maskClosable={false}
        >
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={this.props.onClose}
          >
            <FormItem label={'Payment method'} required={true}>
              <PaymentMethodSelect
                name={'paymentMethodId'}
                value={this.state.data.paymentMethodId}
                onChange={(e: any, method: GQL.IPaymentMethod | undefined) => this.onChange(e)}
              />
            </FormItem>
            <FormItem label={'Price'} required={true}>
              <Input
                name={'paymentTotal'}
                placeholder="Enter payment price"
                addonBefore={order.currency && order.currency.value}
                value={this.state.data.paymentTotal.toString()}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem>
              <Checkbox
                name={'paid'}
                checked={this.state.data.paid}
                onChange={this.onChange}
              >
                Order paid?
              </Checkbox>
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }

  private onChange(e: any) {
    const { name, value, checked } = e.target;

    const inputValue = ( value !== undefined ? value : checked);

    this.setState({
      data: { ...this.state.data, [name]: inputValue }
    });
  }

  private onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onSubmit(this.state.data);
      }
    }
  }
}

export default PaymentSettingsModal;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/PaymentSettings/components/Modal.tsx